<template>
    <div v-wechat-title="title" class="schedulePublish">
        <el-row type="flex" justify="start" style="height: 46px; padding-left: 10px; border-bottom: 2px solid #ebeef5; margin-bottom: 4px">
            <el-tabs v-model="activeScheduleId">
                <el-tab-pane :key="schedule.id" v-for="schedule in schedules" :label="schedule.name" :name="schedule.id"> </el-tab-pane>
            </el-tabs>
        </el-row>
        <el-row style="height: 46px; border-bottom: 2px solid #ebeef5">
            <el-col :span="4" class="ver-hori-center" :style="{ height:'100%' }">
                <el-radio-group v-model="scheduleSet_Type" size="small">
                    <el-radio-button label="userGroup">按人员</el-radio-button>
                    <el-radio-button label="shift">按班次</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="16" v-if="viewType=='week'" style="display:flex;align-items: center;height: 100%">
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" :type="viewType=='day' ? 'primary' : 'plain'" @click="viewType='day'">日</el-button>
                    <el-button size="small" type="primary">周</el-button>
                    <el-button size="small" :type="viewType=='month' ? 'primary' : 'plain'" @click="viewType='month'">月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一周</el-button>
                    <el-button size="small" @click="addDate(0)">本周</el-button>
                    <el-button size="small" @click="addDate(1)">下一周</el-button>
                </el-button-group>
                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    :format="start + ' - ' + end"
                    :picker-options="onPicker"
                    type="week"
                    placeholder="选择周"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="16" v-else-if="viewType=='month'" style="display:flex;align-items: center;height: 100%">
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" :type="viewType=='day' ? 'primary' : 'plain'" @click="viewType='day'">日</el-button>
                    <el-button size="small" :type="viewType=='week' ? 'primary' : 'plain'" @click="viewType='week'">周</el-button>
                    <el-button size="small" type="primary" >月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一月</el-button>
                    <el-button size="small" @click="addDate(0)">本月</el-button>
                    <el-button size="small" @click="addDate(1)">下一月</el-button>
                </el-button-group>
                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    type="month"
                    placeholder="选择月"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="16" v-else style="display:flex;align-items: center;height: 100%">
                <el-button-group style="margin-right:100px;" class="btn-group-custom-style">
                    <el-button size="small" type="primary">日</el-button>
                    <el-button size="small" :type="viewType=='week' ? 'primary' : 'plain'" @click="viewType='week'">周</el-button>
                    <el-button size="small" :type="viewType=='month' ? 'primary' : 'plain'" @click="viewType='month'">月</el-button>
                </el-button-group>
                <el-button-group>
                    <el-button size="small" @click="addDate(-1)">上一日</el-button>
                    <el-button size="small" @click="addDate(0)">今日</el-button>
                    <el-button size="small" @click="addDate(1)">下一日</el-button>
                </el-button-group>
                <el-date-picker
                    ref="weekPicker"
                    size="small"
                    prefix-icon=""
                    v-model="dateValue"
                    type="date"
                    placeholder="选择日期"
                    :style="{ margin:'0 5px' }"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="4" style="text-align: right">
                <el-dropdown @command="exportInfo" v-has-permission="exportPermission">
                    <el-button>导出 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="CurrentPage">当前页</el-dropdown-item>
                        <el-dropdown-item command="OtherPages">其它页</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printInfo" v-has-permission="printPermission">
                    <el-button>打印 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="CurrentPage">当前页</el-dropdown-item>
                        <el-dropdown-item command="OtherPages">其它页</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
        </el-row>
        <el-row><el-col :span="24" style="font-size: 24px; padding: 5px 5px; text-align: center">{{ scheduleTitle }}</el-col>
            </el-row>
        <el-row>
            <el-col :span="24">
                <el-container>
                    <el-main>
                        <div class="calendar" style="height: 100%; width: 100%" v-if="scheduleSet_Type == 'shift'">
                            <el-table :data="shiftTableData" class="calendartable" border :cell-style="tableCellStyle" :height="this.screenHeight2 - 280">
                                <el-table-column fixed type="index" label="序号" align="center" width="40" header-align="center"> </el-table-column>
                                <el-table-column fixed prop="dic_shift_name" label="班次" width="120" align="center" header-align="center">
                                    <div slot-scope="scope">
                                        <div style="font-size: 20px; line-height: 60px; height: 60px; text-align: center">{{ scope.row.dic_shift_name }}</div>
                                    </div>
                                </el-table-column>
                                <el-table-column v-for="col in scheduleTimeSpan" :key="col" width="200" header-align="center">
                                    <template #header> {{ col }}<br />{{ $moment.weekdays($moment(col).day()) }} </template>
                                    <div class="item" slot-scope="scope">
                                        <div class="item__txt" style="position: relative" tag="div">
                                            <el-tag class="usertag" v-for="(user, ix) in scope.row[col]" :key="ix">
                                                {{ user && user.worker_name }}
                                            </el-tag>
                                        </div>
                                    </div>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div v-else>
                            <el-table
                                :data="shiftTableData"
                                class="calendartable"
                                :cell-style="userTableCellStyle"
                                :span-method="objectSpanMethod"
                                border
                                :fit="true"
                                :height="this.screenHeight2 - 280"
                            >
                                <el-table-column prop="ix_seq" label="序号" align="center" width="40" header-align="center"> </el-table-column>
                                <el-table-column prop="worker_name" label="姓名" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_years" label="工作年限" width="100" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_duty" label="职称" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column prop="work_scale" label="岗位/层级" width="120" align="center" header-align="center"></el-table-column>
                                <el-table-column v-for="col in scheduleTimeSpan" :prop="col" :key="col" width="160" header-align="center">
                                    <template #header> {{ col }}<br />{{ $moment.weekdays($moment(col).day()) }} </template>
                                    <div slot-scope="scope" style="min-height: 40px; width: 100%">
                                        <div>
                                            <div style="font-size: 20px; line-height: 40px; height: 40px; text-align: center">{{ scope.row[col].dic_shift_name }}</div>
                                            <div
                                                v-show="scope.row[col].is_overtime || scope.row[col].is_link_annual_leave"
                                                style="
                                                    position: absolute;
                                                    bottom: 0px;
                                                    right: 0px;
                                                    border-top: 8px solid transparent;
                                                    border-left: 8px solid transparent;
                                                    border-right: 8px solid black;
                                                    border-bottom: 8px solid black;
                                                    z-index: 99;
                                                "
                                            ></div>
                                        </div>
                                    </div>
                                </el-table-column>
                                <el-table-column prop="dic_shift_times" width="120" align="center" header-align="center">
                                    <template #header>{{viewType=='week'?'本周上班时长':(viewType=='day'?'本日上班时长':'本月上班时长')}}</template>
                                    <div v-if="scope.row.worker_id!=0" slot-scope="scope">
                                        {{scope.row.dic_shift_times}}
                                    </div>
                                    </el-table-column>
                            </el-table>
                        </div>
                    </el-main>
                    <el-footer style="font-size:20px,padding: 0px 0px">
                        <div>{{ schedule_result.remark }}</div>
                    </el-footer>
                </el-container>
            </el-col>
        </el-row>
        <cus-dialog :title="exportForm.title" :visible.sync="exportForm.dialogFormVisible" width="30%" @confirm="exportByTime()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="daterange" v-model="exportForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <cus-dialog :title="printForm.title" :visible.sync="printForm.dialogFormVisible" width="30%" @confirm="printByTime()">
            <div class="margin10 margin-none-h align-left">
                <item-input type="daterange" v-model="printForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
export default {
    name: `SchedulePublish`,
    props: {},
    components: { draggable },
    data() {
        return {
            title: `排班表`,
            token: this.$route.query.token,
            activeScheduleId: 0,
            activeSchedule: {},
            scheduleSet_Type: `userGroup`,
            viewType: `week`, // 默认显示周视图
            active_row: undefined,
            onPicker: {
                firstDayOfWeek: 1
            },
            dateValue: this.$moment().format(`YYYY/MM/DD`),
            year: ``,
            month: ``,
            week: ``,
            day: ``,
            start: ``, // 起始日期
            end: ``, // 截止日期
            schedule_userGroup: [],
            schedule_sifts: [],
            schedule_result: {},
            issave: false,
            scheduleTimeSpan: [
            ],
            shiftTableData: [],
            save_schedule_result: null,
            printForm: {
                dialogFormVisible: false,
                from_to: [],
                day_doc_code: `SPDay001`,
                week_doc_code: `SPWeek001`,
                month_doc_code: `SPMonth001`,
                title: `日期区间`
            },
            exportForm: {
                dialogFormVisible: false,
                from_to: [],
                title: `日期区间`
            },
            schedules: [],
            exportPermission: `schedule_publish:export`,
            printPermission: `schedule_publish:export`

        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        // 设置视图显示模式,默认显示周视图
        this.changeDatePickerSetScheduleTimeSpan(this.dateValue, 0)
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.loadCurrentUserSchedules().then((activeScheduleId) => {
                this.loadActiveScheduleUserGroupsAndShifts(activeScheduleId).then((sifts) => {
                    this.loadScheduleResultsAndCreateShiftTable()
                })
            })
        })
    },
    mounted() {
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`,
            `permissions`,
            `currentUser`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `active_ward`, `section_auth`, `ward_auth`]),
        userDragOption() {
            return {
                animation: 0,
                group: { name: `user`, put: false, pull: `clone` },
                disabled: false,
                ghostClass: `ghost`,
                sort: false,
                filter: `.undraggable`
            }
        },
        screenHeight2() {
            return this.screenHeight
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        scheduleTitle() {
            let endstr = ``
            if (this.viewType == `day`) {
                endstr = `[${this.$moment(this.dateValue).format(`YYYY-MM-DD`)}]`
            }
            if (this.viewType == `month`) {
                endstr = `[${this.$moment(this.dateValue).format(`YYYY-MM`)}]`
            }
            return this.activeSchedule.schedule_title + endstr
        }
    },
    methods: {
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.worker_id === 0) {
                if (columnIndex === 1) {
                    if (this.viewType == `day`) {
                        return [1, 6]
                    }
                    if (this.viewType == `week`) {
                        return [1, 12]
                    }
                    if (this.viewType == `month`) {
                        return [1, 35]
                    }
                } else {
                    return [1, 1]
                }
            }
        },
        tableCellStyle({ row, column, rowIndex, columnIndex }) {
            let that = this
            let cls = column.property
            let style = ``
            if (cls == `dic_shift_name`) {
                let shift = that.getDicShiftById(row.dic_shift_id)
                if (shift) {
                    style = {
                        "background": shift.back_color,
                        "color": shift.color
                    }
                }
            }

            if (cls !== `dic_shift_name` && cls !== `dic_shift_id` && cls !== `index` && that.active_item[0] == rowIndex && that.active_item[1] == columnIndex) {
                style = {
                    "background": `#ffffff`,
                    "border": `2px solid #0C9781`
                }
            }
            return style
        },
        userTableCellStyle({ row, column, rowIndex, columnIndex }) {
            let that = this
            let colname = column.property
            let style = ``
            if (row.worker_id != 0 && that.scheduleTimeSpan.findIndex(date => date === colname) > -1) {
                let shiftId = row[colname].dic_shift_id
                if (shiftId && shiftId != null && shiftId != ``) {
                    let shift = that.getDicShiftById(shiftId)
                    if (shift) {
                        style = {
                            "background": shift.back_color,
                            "color": shift.color
                        }
                    }
                }
            }
            if (row.worker_id == 0) {
                style = {
                    "font-size": 22,
                    "font-weight": `bold`
                }
            }
            return style
        },
        // 上一日，下一日,上一周，下一周,上一月，下一月
        addDate(prevOrNext) {
            let that = this
            if (prevOrNext == 0) {
                this.dateValue = that.$moment()
            }
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, prevOrNext)
        },
        changeDatePickerSetScheduleTimeSpan(date, prevOrNext = 0) {
            let that = this
            that.scheduleTimeSpan = []
            if (that.viewType == `week`) {
                if (prevOrNext == 0) {
                    let weekOfDay = that.$moment(this.dateValue).format(`E`)
                    let firstday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 1, `days`)
                        .format(`YYYY-MM-DD`)
                    let endday = that
                        .$moment(this.dateValue)
                        .subtract(weekOfDay - 7, `days`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = firstday
                    this.start = firstday
                    this.end = endday
                } else {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .startOf(`week`)
                        .format(`YYYY-MM-DD`)
                    let next = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `week`)
                        .endOf(`week`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = prev

                    this.start = prev
                    this.end = next
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)

                this.scheduleTimeSpan = []
                for (let i = 0; i < 7; i++) {
                    let day = that.$moment(this.start).add(i, `d`).format(`YYYY-MM-DD`)
                    that.scheduleTimeSpan.push(day)
                }
            } else if (that.viewType == `month`) {
                let daysInMonth = 0
                if (prevOrNext == 0) {
                    daysInMonth = that.$moment(this.dateValue).daysInMonth()
                } else {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `month`)
                    this.dateValue = prev
                    daysInMonth = that.$moment(prev).daysInMonth()
                }
                this.week = that.$moment(this.dateValue).week()
                this.month = that.$moment(this.dateValue).month() + 1
                this.year = that.$moment(this.dateValue).year()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.start = that
                    .$moment(this.dateValue).startOf(`month`).format(`YYYY-MM-DD`)
                this.end = that
                    .$moment(this.dateValue).endOf(`month`).format(`YYYY-MM-DD`)
                for (let i = 1; i <= daysInMonth; i++) {
                    that.scheduleTimeSpan.push(that.$moment(this.dateValue).date(i).format(`YYYY-MM-DD`))
                }
            } else {
                if (prevOrNext !== 0) {
                    let prev = that
                        .$moment(this.dateValue)
                        .subtract(-prevOrNext, `day`)
                        .format(`YYYY-MM-DD`)
                    this.dateValue = prev
                }
                this.year = that.$moment(this.dateValue).year()
                this.month = that.$moment(this.dateValue).month() + 1
                this.week = that.$moment(this.dateValue).week()
                this.day = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.start = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                this.end = that.$moment(this.dateValue).format(`YYYY-MM-DD`)
                that.scheduleTimeSpan.push(this.day)
            }
        },
        loadCurrentUserSchedules() {
            let that = this
            return new Promise(resolve => {
                // that.schedules = [{
                //     id: `1`,
                //     name: `医生排班设置`,
                //     schedule_title: `2023年中山市中医院医生排班表`,
                //     display_order: 1,
                //     remark: `aaaaaaaaaaaaaaaaaaa`
                // }, {
                //     id: `2`,
                //     name: `护士排班设置`,
                //     schedule_title: `2023年中山市中医院医生排班表`,
                //     display_order: 2,
                //     remark: `bbbbbbbbbbbbbbbbbbb`
                // }, {
                //     id: `3`,
                //     name: `实习生排班设置`,
                //     schedule_title: `2023年中山市中医院医生排班表`,
                //     display_order: 3,
                //     remark: `ccccccccccccccccccc`
                // }]
                // if (that.schedules && that.schedules.length > 0) {
                //     that.activeScheduleId = that.schedules[0].id
                //     that.activeSchedule = that.schedules[0]
                // }
                // resolve(that.activeScheduleId)

                let req = that.myaxios.get(`/api/AcisSystem/DicSchedule/GetScheduleByUserId?userId=${(this.currentUser && this.currentUser.id) || 0}&type=2`)
                req.then(data => {
                    if (data && data.length > 0) {
                        data.map(i => { i.id = String(i.id) })
                        that.schedules = data
                        that.activeScheduleId = that.schedules[0].id
                        that.activeSchedule = that.schedules[0]
                    }
                    resolve(that.activeScheduleId)
                })
            })
        },
        loadActiveScheduleUserGroupsAndShifts(activeScheduleId) {
            let that = this
            that.schedule_userGroup = []
            that.schedule_sifts = []
            return new Promise(resolve => {
                // 获取排班表设置的用户组
                let req = this.myaxios.get(`/api/AcisSystem/ShiftUserGroup/GetUserGroupByScheduleId?scheduleId=${activeScheduleId}`)
                // 获取排班表设置的班次
                let req1 = this.myaxios.get(`api/AcisSystem/DicShift/GetShiftByScheduleId?scheduleId=${activeScheduleId}`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    that.schedule_userGroup = data
                    that.schedule_sifts = data1
                    resolve(that.schedule_sifts)
                })
            })
        },
        loadScheduleResultsAndCreateShiftTable() {
            let that = this
            that.shiftTableData = []
            that.loadScheduleResults().then((results) => {
                if (that.scheduleSet_Type == `shift`) {
                    this.createShiftTableData(results)
                } else {
                    this.createUserTableData(results)
                }
            })
        },
        loadScheduleResults() {
            let that = this
            that.active_item = []
            return new Promise(resolve => {
                let type = this.viewType == `day` ? 1 : (this.viewType == `week` ? 2 : 3)
                let url = `/api/AcisSystem/ScheduleResult/GetScheduleResult?dic_schedule_id=${that.activeScheduleId}&startDT=${that.start}&endDT=${that.end}&type=${type}&status=2`

                that.myaxios.get(url).then(data => {
                    if (data != null) {
                        that.schedule_result = data
                        if (that.schedule_result.id == 0) {
                            that.schedule_result = {
                                name: ``,
                                dic_schedule_id: that.activeScheduleId,
                                year: this.year,
                                month: this.month,
                                week: this.week,
                                start_dt: this.start,
                                schedule_dt: that.$moment(that.dateValue).format(`YYYY-MM-DD`),
                                end_dt: this.end,
                                status: 1,
                                type: type,
                                status_name: `未发布`,
                                remark: that.activeSchedule.remark
                            }
                            that.schedule_result.result_details = data.result_details
                        }
                    } else {
                        that.schedule_result = { id: 0,
                            name: ``,
                            dic_schedule_id: that.activeScheduleId,
                            year: this.year,
                            week: this.week,
                            start_dt: this.start,
                            end_dt: this.end,
                            status: 1,
                            status_name: `未发布`,
                            type: type,
                            remark: that.activeSchedule.remark,
                            result_details: [] }
                    }

                    resolve(that.schedule_result)
                })
            })
        },
        createShiftTableData(results) {
            let that = this
            that.shiftTableData = []
            let row = {
                'dic_shift_id': 0,
                'dic_shift_name': ``

            }
            let resultDetails = results.result_details
            if (that.scheduleTimeSpan.length > 0) {
                for (let i = 0; i < that.scheduleTimeSpan.length; i++) {
                    this.$set(row, that.scheduleTimeSpan[i], [])
                }
            }

            // 创建table rows
            if (that.schedule_sifts && that.schedule_sifts.length > 0) {
                let sifts = that.schedule_sifts

                for (let i = 0; i < sifts.length; i++) {
                    let shiftusers = _.filter(resultDetails, (d) => {
                        return d.dic_shift_id === sifts[i].dic_shift_id
                    }) || []

                    var newrow = Object.assign({}, row)
                    newrow[`dic_shift_id`] = sifts[i].dic_shift_id
                    newrow[`dic_shift_name`] = sifts[i].dic_shift_name
                    if (shiftusers.length > 0) {
                        for (let index = 0; index < that.scheduleTimeSpan.length; index++) {
                            let shiftDateUsers = _.filter(shiftusers, (d) => {
                                return (d.schedule_date && that.$moment(d.schedule_date).format(`YYYY-MM-DD`) === that.scheduleTimeSpan[index])
                            }) || []
                            newrow[that.scheduleTimeSpan[index]] = shiftDateUsers
                        }
                    }
                    that.shiftTableData.push(newrow)
                }
            }
        },
        createUserTableData(results) {
            let that = this
            that.shiftTableData = []
            let row = {
                'ix_seq': null,
                'worker_id': 0,
                'worker_name': ``,
                'work_years': ``,
                'work_duty': ``,
                'work_scale': ``
            }
            let resultDetails = results.result_details

            // 创建table rows  xxxx
            let workers = that.getWorkers(that.schedule_userGroup)
            if (workers && workers.length > 0) {
                for (let i = 0; i < workers.length; i++) {
                    // 这里最好按>本周开始且<本周结束过滤一下
                    let workerResults = _.filter(resultDetails, (d) => {
                        return d.worker_id === workers[i].worker_id
                    }) || []

                    var newrow = Object.assign({}, row)

                    newrow[`ix_seq`] = workers[i].ix_seq
                    newrow[`worker_id`] = workers[i].worker_id
                    newrow[`worker_name`] = workers[i].worker_name
                    newrow[`work_years`] = workers[i].work_years
                    newrow[`work_duty`] = workers[i].work_duty
                    newrow[`work_scale`] = workers[i].work_scale

                    for (let index = 0; index < that.scheduleTimeSpan.length; index++) {
                        let userDateShifts = _.filter(workerResults, (d) => {
                            return (d.schedule_date && that.$moment(d.schedule_date).format(`YYYY-MM-DD`) === that.scheduleTimeSpan[index])
                        })
                        if (userDateShifts && userDateShifts.length > 0) {
                            newrow[that.scheduleTimeSpan[index]] = userDateShifts[0]
                            // newrow[that.scheduleTimeSpan[index]] = userDateShifts[0].dic_shift_id
                        } else {
                            newrow[that.scheduleTimeSpan[index]] = { dic_shift_id: null, is_overtime: null, over_long_time: null, is_link_annual_leave: null }
                        }
                        let sumWorkerMinutes = _.sumBy(workerResults,
                            d => d.dic_shift_times
                        )
                        newrow[`dic_shift_times`] = that.getTimes(sumWorkerMinutes)
                    }
                    that.shiftTableData.push(newrow)
                }
            }
        },
        getWorkers() {
            let that = this
            let workers = []
            _.forEach(that.schedule_userGroup, row => {
                let workergroup = {
                    ix_seq: null,
                    worker_id: 0,
                    count: 0,
                    worker_code: ``,
                    worker_name: row.name,
                    work_duty: null,
                    work_scale: null,
                    work_years: null
                }
                workers.push(workergroup)
                for (let i = 0; i < row.users.length; i++) {
                    let worker = {
                        ix_seq: i + 1,
                        worker_id: row.users[i].worker_id,
                        count: 0,
                        worker_code: ``,
                        worker_name: row.users[i].worker_name,
                        work_duty: row.users[i].enum_worker_dutyname,
                        work_scale: row.users[i].enum_post_name + `/` + row.users[i].enum_level_name,
                        work_years: that.getWorkYears(row.users[i].entry_time)
                    }
                    workers.push(worker)
                }
                // let users = JSON.parse(JSON.stringify(row.users))
                // workers = workers.concat(users)
            })
            return workers
        },
        getTimes(minutes) {
            let that = this
            let minuteTitle = that.$moment().utc().startOf(`day`).add(minutes, `minutes`).format(`H小时mm`).replace(`00`, ``)
            return minuteTitle
        },
        getWorkYears(entryTime) {
            if (!entryTime) {
                return ``
            } else {
                let duration = this.$moment().diff(this.$moment(entryTime), `years`)
                if (duration < 1) {
                    let durationMonths = this.$moment().diff(this.$moment(entryTime), `months`)
                    return durationMonths + `月`
                } else {
                    return this.$moment().diff(this.$moment(entryTime), `years`) + `年`
                }
            }
        },
        getDicShiftById(id) {
            let that = this
            return _.find(that.schedule_sifts, x => x.dic_shift_id == id)
        },
        getDicShiftName(id) {
            let that = this
            let item = _.find(that.schedule_sifts, x => x.dic_shift_id == id)
            if (item) { return item.dic_shift_name || `` }
            return ``
        },
        exportInfo(command) {
            let that = this
            // 当前页
            if (command == `CurrentPage`) {
                let from = null
                let to = null
                let type = 0
                if (that.viewType == `day`) {
                    from = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                    to = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                    type = 1
                }
                if (that.viewType == `week` || that.viewType == `month`) {
                    from = this.$moment(that.start).format(`YYYY-MM-DD`)
                    to = this.$moment(that.end).format(`YYYY-MM-DD`)
                    type = that.viewType == `week` ? 2 : 3
                }
                this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetScheduleResultForExport`, { dic_schedule_id: that.activeScheduleId, from: from, to: to, type: type }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    this.myaxios.export_excel_Extradata(
                        `api/Operation/Home/ExcelFile_Schedule`,
                        data,
                        `排班结果.xls`,
                        data[0].标题
                    )
                }).catch(e => {
                    console.log(e)
                })
            } else { // 其他页
                this.exportForm.dialogFormVisible = true
            }
        },
        exportByTime() {
            let that = this
            let from = this.$moment(that.exportForm.from_to[0]).format(`YYYY-MM-DD`)
            let to = this.$moment(that.exportForm.from_to[1]).format(`YYYY-MM-DD`)
            let type = that.viewType == `day` ? 1 : (that.viewType == `week` ? 2 : 3)
            this.myaxios.get(`/api/AcisSystem/ScheduleResult/GetScheduleResultForExport`, { dic_schedule_id: that.activeScheduleId, from: from, to: to, type: type }).then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel_Extradata(
                    `api/Operation/Home/ExcelFile_Schedule`,
                    data,
                    `排班结果.xls`,
                    data[0].标题
                )
            }).catch(e => {
                console.log(e)
            })
        },
        printInfo(command) {
            let that = this
            // 当前页
            let docCode = ``
            let from = null
            let to = null
            if (that.viewType == `day`) {
                docCode = that.printForm.day_doc_code
                from = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
                to = this.$moment(that.dateValue).format(`YYYY-MM-DD`)
            } else if (that.viewType == `month`) {
                docCode = that.printForm.month_doc_code
                from = that.start
                to = that.end
            } else {
                docCode = that.printForm.week_doc_code
                from = that.start
                to = that.end
            }

            if (command == `CurrentPage`) {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[docCode],
                                id1: `${that.schedule_result.dic_schedule_id}`,
                                objId: ``,
                                from: this.$moment(from).format(`YYYYMMDDHHmm`),
                                to: this.$moment(to).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            } else { // 其他页
                this.printForm.dialogFormVisible = true
            }
        },
        printByTime() {
            let that = this
            this.printForm.dialogFormVisible = false
            let docCode = ``
            if (that.viewType == `day`) {
                docCode = that.printForm.day_doc_code
            } else if (that.viewType == `month`) {
                docCode = that.printForm.month_doc_code
            } else {
                docCode = that.printForm.week_doc_code
            }
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[docCode],
                            id1: `${that.schedule_result.dic_schedule_id}`,
                            objId: ``,
                            from: this.$moment(that.printForm.from_to[0]).format(`YYYYMMDDHHmm`),
                            to: this.$moment(that.printForm.from_to[1]).format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        activeScheduleId: function() {
            if (this.activeScheduleId != 0) {
                this.loadActiveScheduleUserGroupsAndShifts(this.activeScheduleId).then((sifts) => {
                    this.loadScheduleResultsAndCreateShiftTable()
                })
            }
        },
        scheduleSet_Type: function() {
            this.loadScheduleResultsAndCreateShiftTable()
        },
        dateValue: function() {
            let that = this
            that.changeDatePickerSetScheduleTimeSpan(that.dateValue, 0)
            if (this.activeScheduleId != 0) {
                this.loadScheduleResultsAndCreateShiftTable()
            }
        },
        viewType: function() {
            this.dateValue = this.$moment()
        }

    }
}
</script>
<style scoped lang="less">
.schedulePublish {
    background: #ffffff;
    height: 100%;
    /deep/ .el-table th > .cell {
        height: auto !important;
        line-height: inherit !important;
    }
    /deep/ .el-header {
        height: 48px !important;
        padding: 0 0px;
        background: #ffffff;
    }
    /deep/ .el-main {
        padding: 0 0px;
    }
    /deep/ .calendartable {
        width: 100%;
    }

    /deep/ .el-table tbody tr:hover > td {
        // background: #ffffff !important;
    }
    /deep/ .el-table th {
        background: #ffffff !important;
    }

    /deep/ .item {
        .item__txt {
            min-height: 150px !important;
            box-sizing: border-box;
            // border: 1px solid transparent;
        }
        .item__txt--hover {
            border: 1px solid #dddddd;
            border-radius: 4px;
            cursor: pointer;
            background-color: #ffffff;
        }
        .item__txt--click {
            border: 2px solid #0c9781;
            background-color: #ffffff;
        }
    }

    /deep/ .elSelect-Class {
        /deep/ .el-input {
            input {
                height: 60px !important;
            }
        }
    }
    /deep/ .setworkerdialog {
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            background: none;
            min-height: 100px !important;
        }

        /deep/ .remotemultiselect {
            .el-input {
                input {
                    min-height: 80px !important;
                    width: 340px;
                }
            }
            .el-input__inner {
                padding-left: 5px !important;
            }
            &.el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }
            .el-input--suffix .el-input__inner {
                padding-right: 5px !important;
            }
            .el-input__prefix {
                display: none;
            }
        }
    }
}

.user {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 170px;
}
.usertag {
    margin-right: 5px;
    margin-bottom: 3px;
    min-width: 83px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 200px;
}

/deep/ .el-tabs__nav-wrap::after{
    background-color: #ffffff !important;
}

.btn-group-custom-style{
    /deep/ .el-button {
        &:not(:first-of-type){
            margin-left: 0 !important;
            border-left-width: 0;
        }

        &:not(:last-of-type){
            margin-right: 0 !important;
            border-right-width: 0;
        }
    }
}

.ver-hori-center{
    display: flex;
    justify-content: center;
    align-items: center;
}

.schedulePublish /deep/ .el-table th {
    background-color: #fafafa !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduleShift/SchedulePublish.vue